<template>
  <v-row dense v-if="shouldShowConfiguration()">
    <v-col>
      <v-card>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-row dense>
                <v-col cols="12">
                  <h3>Service Configuration</h3>
                </v-col>
              </v-row>
              <v-row dense>
                <v-col cols="6" v-if="moduleData.customer_field1 !== null
                && moduleData.customer_field1.length > 0">
                  <v-text-field
                    :label="moduleData.customer_field1"
                    v-model="moduleData.customer_field1_value"
                    :readonly="isTelegramField(moduleData.customer_field1) ? false : readonly"
                    :rules="[]"></v-text-field>
                  <ul v-show="moduleData.customer_field1 === 'Telegram Bot Key'">
                    <li>1.Open @BotFather on Telegram.</li>
                    <li>2.Type /newbot and follow the prompts.</li>
                    <li>3.Copy the bot token and paste it below.</li>
                    <li>
                      <v-btn x-small
                               color="success"
                               @click="watchGuide1"
                      >Watch Guide</v-btn>
                    </li>
                  </ul>
                </v-col>
                <v-col cols="6" v-if="moduleData.customer_field2 !== null
                && moduleData.customer_field2.length > 0">
                  <v-text-field
                    :label="moduleData.customer_field2"
                    v-model="moduleData.customer_field2_value"
                    :readonly="isTelegramField(moduleData.customer_field1) ? false : readonly"
                    :rules="[]"></v-text-field>
                  <div v-show="moduleData.customer_field2 === 'Telegram User Allow List'">
                    <p><b>Only allowed users will be able to talk
                      to your AI agent. Use Comma (,) to separate multiple user IDs.</b></p>
                    <ul>
                      <li>1.Open @cldy_info_bot on Telegram.</li>
                      <li>2.Click Start</li>
                      <li>3.Copy the id and paste it below.</li>
                      <li>
                        <v-btn x-small
                                 color="success"
                                 @click="watchGuide2"
                        >Watch Guide</v-btn>
                      </li>
                    </ul>
                  </div>
                </v-col>
                <v-col v-if="hasTelegramFields" cols="12" class="text-right">
                  <v-btn
                    color="primary"
                    :loading="processing"
                    @click="submitManualFields"
                  >Update Telegram</v-btn>
                </v-col>
                <v-col cols="6" v-if="moduleData.customer_field3 !== null
                && moduleData.customer_field3.length > 0">
                  <v-text-field
                    :label="moduleData.customer_field3"
                    v-model="moduleData.customer_field3_value"
                    :readonly="isTelegramField(moduleData.customer_field1) ? false : readonly"
                    :rules="[]"></v-text-field>
                  <div v-show="moduleData.customer_field3 === 'WebUI Token'">
                    <p>Your token is encrypted and never shared.
                      Generate a new one if you suspect your ai agent login is compromised.
                    </p>
                    <p>Login with WebUI Token: <a href="https://agent.cldy.com/">https://agent.cldy.com/</a></p>
                    <p>Service ID: {{ serviceId }}</p>
                  </div>
                </v-col>
                <v-col v-if="hasTelegramFields" cols="12" class="text-right">
                  <v-btn
                    color="primary"
                    :loading="processing"
                    @click="refreshWebUiToken"
                  >Regenerate WebUI Token</v-btn>
                </v-col>
                <v-col cols="6" v-if="moduleData.customer_field4 !== null
                && moduleData.customer_field4.length > 0">
                  <v-text-field
                    :label="moduleData.customer_field4"
                    v-model="moduleData.customer_field4_value"
                    :readonly="isTelegramField(moduleData.customer_field1) ? false : readonly"
                    :rules="[]"></v-text-field>
                </v-col>
                <v-col cols="6" v-if="moduleData.customer_field5 !== null
                && moduleData.customer_field5.length > 0">
                  <v-text-field
                    :label="moduleData.customer_field5"
                    v-model="moduleData.customer_field5_value"
                    :readonly="isTelegramField(moduleData.customer_field1) ? false : readonly"
                    :rules="[]"></v-text-field>
                </v-col>
                <v-col cols="6" v-if="moduleData.customer_field6 !== null
                && moduleData.customer_field6.length > 0">
                  <v-text-field
                    :label="moduleData.customer_field6"
                    v-model="moduleData.customer_field6_value"
                    :readonly="isTelegramField(moduleData.customer_field1) ? false : readonly"
                    :rules="[]"></v-text-field>
                </v-col>
                <v-col cols="6" v-if="moduleData.customer_field7 !== null
                && moduleData.customer_field7.length > 0">
                  <v-text-field
                    :label="moduleData.customer_field7"
                    v-model="moduleData.customer_field7_value"
                    :readonly="isTelegramField(moduleData.customer_field1) ? false : readonly"
                    :rules="[]"></v-text-field>
                </v-col>
                <v-col cols="6" v-if="moduleData.customer_field8 !== null
                && moduleData.customer_field8.length > 0">
                  <v-text-field
                    :label="moduleData.customer_field8"
                    v-model="moduleData.customer_field8_value"
                    :readonly="isTelegramField(moduleData.customer_field1) ? false : readonly"
                    :rules="[]"></v-text-field>
                </v-col>
                <v-col cols="6" v-if="moduleData.customer_field9 !== null
                && moduleData.customer_field9.length > 0">
                  <v-text-field
                    :label="moduleData.customer_field9"
                    v-model="moduleData.customer_field9_value"
                    :readonly="isTelegramField(moduleData.customer_field1) ? false : readonly"
                    :rules="[]"></v-text-field>
                </v-col>
                <v-col cols="6" v-if="moduleData.customer_field10 !== null
                && moduleData.customer_field10.length > 0">
                  <v-text-field
                    :label="moduleData.customer_field10"
                    v-model="moduleData.customer_field10_value"
                    :readonly="isTelegramField(moduleData.customer_field1) ? false : readonly"
                    :rules="[]"></v-text-field>
                </v-col>
              </v-row>
              <v-divider></v-divider>
              <v-row v-if="!hideAdminInfo" dense>
                <v-col cols="12">
                  <h2>Admin Fields</h2>
                </v-col>
              </v-row>
              <v-row v-if="!hideAdminInfo" dense>
                <v-col cols="6" v-if="moduleData.admin_field1 !== null
                && moduleData.admin_field1.length > 0">
                  <v-text-field
                    :label="moduleData.admin_field1"
                    v-model="moduleData.admin_field1_value"
                    :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="6" v-if="moduleData.admin_field2 !== null
                && moduleData.admin_field2.length > 0">
                  <v-text-field
                    :label="moduleData.admin_field2"
                    v-model="moduleData.admin_field2_value"
                    :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="6" v-if="moduleData.admin_field3 !== null
                && moduleData.admin_field3.length > 0">
                  <v-text-field
                    :label="moduleData.admin_field3"
                    v-model="moduleData.admin_field3_value"
                    :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="6" v-if="moduleData.admin_field4 !== null
                && moduleData.admin_field4.length > 0">
                  <v-text-field
                    :label="moduleData.admin_field4"
                    v-model="moduleData.admin_field4_value"
                    :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="6" v-if="moduleData.admin_field5 !== null
                && moduleData.admin_field5.length > 0">
                  <v-text-field
                    :label="moduleData.admin_field5"
                    v-model="moduleData.admin_field5_value"
                    :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="6" v-if="moduleData.admin_field6 !== null
                && moduleData.admin_field6.length > 0">
                  <v-text-field
                    :label="moduleData.admin_field6"
                    v-model="moduleData.admin_field6_value"
                    :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="6" v-if="moduleData.admin_field7 !== null
                && moduleData.admin_field7.length > 0">
                  <v-text-field
                    :label="moduleData.admin_field7"
                    v-model="moduleData.admin_field7_value"
                    :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="6" v-if="moduleData.admin_field8 !== null
                && moduleData.admin_field8.length > 0">
                  <v-text-field
                    :label="moduleData.admin_field8"
                    v-model="moduleData.admin_field8_value"
                    :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="6" v-if="moduleData.admin_field9 !== null
                && moduleData.admin_field9.length > 0">
                  <v-text-field
                    :label="moduleData.admin_field9"
                    v-model="moduleData.admin_field9_value"
                    :rules="[rules.required]"></v-text-field>
                </v-col>
                <v-col cols="6" v-if="moduleData.admin_field10 !== null
                && moduleData.admin_field10.length > 0">
                  <v-text-field
                    :label="moduleData.admin_field10"
                    v-model="moduleData.admin_field10_value"
                    :rules="[rules.required]"></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'Manage',
  data() {
    return {
      processing: false,
      moduleData: {
        domain: '',
        admin_field1: '',
        admin_field2: '',
        admin_field3: '',
        admin_field4: '',
        admin_field5: '',
        admin_field6: '',
        admin_field7: '',
        admin_field8: '',
        admin_field9: '',
        admin_field10: '',
        admin_field1_value: '',
        admin_field2_value: '',
        admin_field3_value: '',
        admin_field4_value: '',
        admin_field5_value: '',
        admin_field6_value: '',
        admin_field7_value: '',
        admin_field8_value: '',
        admin_field9_value: '',
        admin_field10_value: '',
        customer_field1: '',
        customer_field2: '',
        customer_field3: '',
        customer_field4: '',
        customer_field5: '',
        customer_field6: '',
        customer_field7: '',
        customer_field8: '',
        customer_field9: '',
        customer_field10: '',
        customer_field1_value: '',
        customer_field2_value: '',
        customer_field3_value: '',
        customer_field4_value: '',
        customer_field5_value: '',
        customer_field6_value: '',
        customer_field7_value: '',
        customer_field8_value: '',
        customer_field9_value: '',
        customer_field10_value: '',
      },
      rules: {
        required: (value) => !!value || 'This field is required.',
        isNumeric: (value) => this.$underscore.isFinite(value) || 'This field must be numeric.',
        domain: (value) => (/(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]/i).test(value) || 'This field must be valid domain name.',
      },
    };
  },
  computed: {
    hasTelegramFields() {
      for (let i = 1; i <= 10; i += 1) {
        const fieldName = this.moduleData[`customer_field${i}`];
        if (fieldName && fieldName.length > 0 && this.isTelegramField(fieldName)) {
          return true;
        }
      }
      return false;
    },
    // Shared by admin and partner pages; admins use the admin copies of the endpoints.
    serviceApiPrefix() {
      return this.$store.state.user.role === 'Admin' ? 'admin/manage' : 'partner';
    },
  },
  mounted() {
    this.$underscore.each(this.parentModuleData, (propV, prop) => {
      if (typeof this.moduleData[prop] !== 'undefined') {
        this.$set(this.moduleData, prop, propV);
      }
    });
  },
  methods: {
    isTelegramField(fieldName) {
      return fieldName && fieldName.startsWith('Telegram');
    },
    shouldShowConfiguration() {
      return (this.moduleData.customer_field1 !== null
          && this.moduleData.customer_field1.length > 0)
        || (this.moduleData.customer_field2 !== null
          && this.moduleData.customer_field2.length > 0)
        || (this.moduleData.customer_field3 !== null
          && this.moduleData.customer_field3.length > 0)
        || (this.moduleData.customer_field4 !== null
          && this.moduleData.customer_field4.length > 0)
        || (this.moduleData.customer_field5 !== null
          && this.moduleData.customer_field5.length > 0)
        || (this.moduleData.customer_field6 !== null
          && this.moduleData.customer_field6.length > 0)
        || (this.moduleData.customer_field7 !== null
          && this.moduleData.customer_field7.length > 0)
        || (this.moduleData.customer_field8 !== null
          && this.moduleData.customer_field8.length > 0)
        || (this.moduleData.customer_field9 !== null
          && this.moduleData.customer_field9.length > 0)
        || (this.moduleData.customer_field10 !== null
          && this.moduleData.customer_field10.length > 0);
    },
    submitManualFields() {
      this.processing = true;
      const payload = {};
      payload.service_id = this.serviceId;
      for (let i = 1; i <= 10; i += 1) {
        const fieldName = this.moduleData[`customer_field${i}`];
        if (fieldName && fieldName.length > 0 && this.isTelegramField(fieldName)) {
          payload[`customer_field${i}`] = fieldName;
          payload[`customer_field${i}_value`] = this.moduleData[`customer_field${i}_value`];
        }
      }
      this.$api.post(`${this.serviceApiPrefix}/service/config-manual`, payload)
        .then(() => {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'success',
            message: 'Configuration fields are updated successfully.',
          });
        })
        .catch((error) => {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: error.response ? error.response.data.message : error.message,
          });
        })
        .finally(() => {
          this.processing = false;
        });
    },
    refreshWebUiToken() {
      this.processing = true;
      const payload = {};
      payload.service_id = this.serviceId;
      for (let i = 1; i <= 10; i += 1) {
        const fieldName = this.moduleData[`customer_field${i}`];
        if (fieldName && fieldName.length > 0 && this.isTelegramField(fieldName)) {
          payload[`customer_field${i}`] = fieldName;
          payload[`customer_field${i}_value`] = this.moduleData[`customer_field${i}_value`];
        }
      }
      this.$api.post(`${this.serviceApiPrefix}/service/config-manual-webui`, payload)
        .then((response) => {
          this.moduleData.customer_field3 = response.data.webui_token;
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'success',
            message: 'WebUI token are regenerated successfully.',
          });
        })
        .catch((error) => {
          this.$store.dispatch('addAlert', {
            id: Date.now(),
            type: 'error',
            message: error.response ? error.response.data.message : error.message,
          });
        })
        .finally(() => {
          this.processing = false;
        });
    },
    watchGuide1() {
      window.open('/telegram_get_token.mp4', '_blank').focus();
    },
    watchGuide2() {
      window.open('/telegram_get_userid.gif', '_blank').focus();
    },
  },
  props: {
    serviceId: {
      type: [String, Number],
      default: null,
    },
    readonly: {
      type: Boolean,
      default() {
        return true;
      },
    },
    hideAdminInfo: {
      type: Boolean,
      default() {
        return false;
      },
    },
    parentModuleData: {
      type: Object,
      default() {
        return {
          domain: '',
          admin_field1: '',
          admin_field2: '',
          admin_field3: '',
          admin_field4: '',
          admin_field5: '',
          admin_field6: '',
          admin_field7: '',
          admin_field8: '',
          admin_field9: '',
          admin_field10: '',
          admin_field1_value: '',
          admin_field2_value: '',
          admin_field3_value: '',
          admin_field4_value: '',
          admin_field5_value: '',
          admin_field6_value: '',
          admin_field7_value: '',
          admin_field8_value: '',
          admin_field9_value: '',
          admin_field10_value: '',
          customer_field1: '',
          customer_field2: '',
          customer_field3: '',
          customer_field4: '',
          customer_field5: '',
          customer_field6: '',
          customer_field7: '',
          customer_field8: '',
          customer_field9: '',
          customer_field10: '',
          customer_field1_value: '',
          customer_field2_value: '',
          customer_field3_value: '',
          customer_field4_value: '',
          customer_field5_value: '',
          customer_field6_value: '',
          customer_field7_value: '',
          customer_field8_value: '',
          customer_field9_value: '',
          customer_field10_value: '',
        };
      },
    },
  },
  watch: {
    moduleData: {
      handler(newModuleData) {
        this.$emit('update:moduleData', newModuleData);
      },
      deep: true,
    },
    parentModuleData: {
      handler(newParentModuleData) {
        this.$underscore.each(newParentModuleData, (propV, prop) => {
          if (typeof this.moduleData[prop] !== 'undefined') {
            this.$set(this.moduleData, prop, propV);
          }
        });
      },
      deep: true,
    },
  },
};
</script>

<style scoped>

</style>
